
<template>
  <section class="container">
    <v-data-table
    :headers="headers"
    :items="desserts"
    :items-per-page="10"
    class="elevation-1"
    mobile-breakpoint="0"
  >
<template v-for="header in headers" v-slot:[`header.${header.value}`]="{ headers }">
    <!-- {{ header.text }} -->
    <span v-if="header.text=='image1'"><img style="height:50px;width:50px" :src="require(`@/assets/studio_window.png`)" /></span>
    <span v-if="header.text=='image2'"><img style="height:50px;width:50px" :src="require('@/assets/studio_window_black.png')" /></span>
</template>
  </v-data-table>
  </section>
  
</template>
<script>
 export default {
        name:"App",
        data(){
            return {
                sideNav: false,
                menuItems: [
                  
                ],
        headers: [
          {
            text: '',
            align: 'start',
            sortable: false,
            value: 'name',
          },
          { text: 'image1', value: 'description' },
          { text: 'image2', value: 'description2' },
        ],
        desserts: [
          {
            name: 'Series',
            description: "Studio",
            description2:"Artisan"
          },
          {
            name: 'Types',
            description: "Single Hung Horizontal Slider",
            description2:"Single Hung Horizontal Slider"
          },
          {
            name: 'Warranty',
            description: "10 years",
            description2:"10 years"
          },
          {
            name: 'Color Options',
            description: "White Almond Black/Black",
            description2:"White Almond Black/Black"
          },
          {
            name: 'Hardware',
            description: "4 Options",
            description2:"4 Options"
          },
          {
            name: 'Frame Styles',
            description: "Flush Fin",
            description2:"Flush Fin"
          },
          {
            name: 'Glass Options',
            description: "Low E Glass",
            description2:"Low E Glass"
          },
          {
            name: 'Grid Options',
            description: "5'8 Flat Grid",
            description2:"5'8 Flat Grid"
          },
          {
            name: 'Performance Values',
            description: "Values",
            description2:"Values"
          },
          {
            name: 'Price',
           description: "$",
            description2:"$$"
          },
        ],
      
    
            }
        },
        mounted() {
            console.log('App Component mounted.')
        },
      
    }
</script>

<style scoped>

</style>